module.exports = __webpack_public_path__ + "static/media/marines2.0a286232.png";